import { createLegacyRoute, createStaticRoute } from './routeUtils'
import { appRoutes, IntegrationRouteParams } from './appRoutes'
import { integrationKeyByType } from '../types/integrationTypeUtils'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { SyncStore } from '../store/syncStore'

const createRoute = createLegacyRoute

type MpCardIdRouteParams = {
  id: string;
  productId?: string,
};

type NewAccountRouteParams = Pick<IntegrationRouteParams, 'integration'>

const createMpCardSettingsRoutes = () => ({
  new: createRoute<NewAccountRouteParams>()`/settings/new/${'integration'}`
})

export const createMpCardRoutes = () => ({
  main: createStaticRoute('/'),
  account: createStaticRoute('/account'),
  // reviews: createStaticRoute('/reviews'),
  settings: createMpCardSettingsRoutes(),
  newCard: createStaticRoute('/card'),
  card: createRoute<MpCardIdRouteParams>()`/card/${'id'}`,
  import: createRoute<MpCardIdRouteParams>()`/card/${'productId'}/${'id'}`,
  editCards: createStaticRoute('/edit'),
  moveCards: createStaticRoute('/move')
  // moySkladSettings: createRoute<StoreRouteParams>()`/${'integration'}/settings`
})

export const mpCardRoutes = createMpCardRoutes()

const mpCardNonAccountPathPrefixes = [
  '/card',
  '/edit',
  '/move',
  '/settings',
  '/account',
  '/admin'
] as const

export const isMpCardNonAccountPath =
  (pathname: string): boolean =>
    mpCardNonAccountPathPrefixes.some(
      prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )

export const makeMpCardAccountUrl =
  (integrationType: IntegrationType, accountId: number): string =>
    appRoutes.Store.makeUrl({
      integration: integrationKeyByType[integrationType],
      accountId
    })

export const getFirstMpCardAccountUrl =
  (syncStore: SyncStore): string | null => {
    if (syncStore.ozonAccounts.length > 0) {
      return makeMpCardAccountUrl(IntegrationType.Ozon, syncStore.ozonAccounts[0].id)
    }

    if (syncStore.wbAccounts.length > 0) {
      return makeMpCardAccountUrl(IntegrationType.Wildberries, syncStore.wbAccounts[0].id)
    }

    if (syncStore.yandexMarketAccounts.length > 0) {
      return makeMpCardAccountUrl(IntegrationType.YandexMarket, syncStore.yandexMarketAccounts[0].id)
    }

    if (syncStore.moySkladAccount) {
      return makeMpCardAccountUrl(IntegrationType.MoySklad, syncStore.moySkladAccount.id)
    }

    return null
  }